import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Quickfilter from './Quickfilter'
import Sticky from 'react-stickynode'
import './sidebarMenu.pcss'
import SidebarNameDays from '../../components/widgets/SidebarNamedays'
import { SkyscraperAd, SKYSCRAPER_1 } from '../../ad/Ad'
import { selectIsNightModeEnabled, selectIsUserLoggedIn } from '../../selectors/userSelector'
import { selectActivePresetProfileId } from '../../selectors/profilesSelector'
import NightModeButton from '../../components/ui/NightModeButton'
import SidebarMenuList from './SidebarMenuList'

/* IMPORTANT:
* When using SidebarMenu component on a page make sure to include the id='sticky-ad-bottom-boundary'
* property on the pages content div, so that on small height screens the sticky ad does not scroll over the footer
* --Yacine
*/

const SidebarMenu = () => {
  const dispatch = useDispatch()
  const activePresetProfileId = useSelector(selectActivePresetProfileId)
  const nightMode = useSelector(selectIsNightModeEnabled)
  const timestamp = useSelector((state) => state.time.get('timestamp'))
  const loggedIn = useSelector(selectIsUserLoggedIn)

  return (
    <div className='menu-container'>
      <div className='menu-content'>
        { !loggedIn &&
          <NightModeButton
            dispatch={ dispatch }
            nightMode={ nightMode }
          />
        }
        <div className='quickfilter' style={ { display: 'none' } }>
          <Quickfilter
            dispatch={ dispatch }
            loggedIn={ loggedIn }
            activePresetProfileId={ activePresetProfileId }
          />
        </div>
        <nav aria-label='Kategoriat'>
          <SidebarMenuList />
        </nav>

        <SidebarNameDays timestamp={ timestamp } />
      </div>

      <Sticky top={ 50 } bottomBoundary='#sticky-ad-bottom-boundary'>
        <SkyscraperAd
          adUnitId={ SKYSCRAPER_1 }
        />
      </Sticky>
    </div>
  )
}

export default SidebarMenu
